const getAdminBaseUrl = () => {
  const rawBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    "http://localhost:18009/admin";
  const trimmed = rawBase.replace(/\/+$/, "");
  return trimmed.endsWith("/admin") ? trimmed : `${trimmed}/admin`;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token") || localStorage.getItem("adminToken");
  if (!token) return { "Content-Type": "application/json" };
  return {
    "Content-Type": "application/json",
    Authorization: token.startsWith("Basic ") || token.startsWith("Bearer ") ? token : `Bearer ${token}`,
  };
};

const handleApiResponse = async (response) => {
  const contentType = response.headers.get("content-type");
  const isJson = contentType && contentType.includes("application/json");
  const result = isJson ? await response.json() : await response.text();

  if (!response.ok || (typeof result === "object" && result.status === false)) {
    const errorMsg =
      (typeof result === "object" &&
        (result?.error?.message || result?.error || result?.message)) ||
      (typeof result === "string" ? result : "API request failed");
    throw new Error(errorMsg);
  }

  return result;
};

export const getUserCustomGameSettings = async (userId) => {
  const baseUrl = getAdminBaseUrl();
  const response = await fetch(`${baseUrl}/users/${userId}/game-settings`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return handleApiResponse(response);
};

export const saveUserCustomGameSettings = async (userId, gameKey, payload) => {
  const baseUrl = getAdminBaseUrl();
  const response = await fetch(`${baseUrl}/users/${userId}/game-settings/${gameKey}`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  return handleApiResponse(response);
};

export const deleteUserCustomGameSettings = async (userId, gameKey) => {
  const baseUrl = getAdminBaseUrl();
  const response = await fetch(`${baseUrl}/users/${userId}/game-settings/${gameKey}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleApiResponse(response);
};
